module.exports = __webpack_public_path__ + "static/media/payment-page.4196aa1e.png";